const config = {
  // basename: only at build time to set, and Don't add '/' at end off BASENAME for breadcrumbs, also Don't put only '/' use blank('') instead,
  // like '/berry-material-react/react/default'
  basename: '/',
  defaultPath: '/',
  fontFamily: `'Roboto', sans-serif`,
  borderRadius: 12,
  theme:'light',
  presetColor:'theme3',
  rtlLayout: true,
  captcha: {
    getText: false,      // Disable captcha at get text modal
    publishText: false,  // Disable captcha at publish note modal
    publishPage: true    // Keep captcha at publish page modal
  },
  autoPublish: true      // Automatically publish pages without pending state
};

export default config;
